import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import CentralHub from './CentralHub';
import WindowManager from './WindowManager';
import Taskbar from './Taskbar';
import StatusWidgets from './StatusWidgets';
import BackgroundEffects from './BackgroundEffects';

export const Desktop = () => {
  const [windows, setWindows] = useState([]);
  const [hubExpanded, setHubExpanded] = useState(false); // Using 'hubExpanded'
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const openWindow = (appId, title, content) => {
    const newWindow = {
      id: `window-${Date.now()}`,
      appId,
      title,
      content,
      x: 100 + windows.length * 30,
      y: 80 + windows.length * 30,
      width: 800,
      height: 600,
      zIndex: windows.length + 100,
      minimized: false,
      maximized: false
    };
    setWindows([...windows, newWindow]);
  };

  const closeWindow = (id) => {
    setWindows(windows.filter(w => w.id !== id));
  };

  const focusWindow = (id) => {
    const maxZ = Math.max(...windows.map(w => w.zIndex), 100);
    setWindows(windows.map(w => 
      w.id === id ? { ...w, zIndex: maxZ + 1 } : w
    ));
  };

  const updateWindow = (id, updates) => {
    setWindows(windows.map(w => 
      w.id === id ? { ...w, ...updates } : w
    ));
  };

  const minimizeWindow = (id) => {
    updateWindow(id, { minimized: true });
  };

  const restoreWindow = (id) => {
    updateWindow(id, { minimized: false });
    focusWindow(id);
  };

  const maximizeWindow = (id) => {
    const window = windows.find(w => w.id === id);
    if (window.maximized) {
      updateWindow(id, { 
        maximized: false,
        x: 100,
        y: 80,
        width: 800,
        height: 600
      });
    } else {
      updateWindow(id, { 
        maximized: true,
        x: 0,
        y: 0,
        width: window.innerWidth || 1920,
        height: (window.innerHeight || 1080) - 60
      });
    }
  };

  return (
    <div className="relative w-screen h-screen overflow-hidden bg-background">
      <BackgroundEffects />
      <StatusWidgets currentTime={currentTime} />

      {/* FIXED CENTRAL HUB PROPS */}
      <CentralHub 
        expanded={hubExpanded} 
        onToggle={() => setHubExpanded(!hubExpanded)}
        windows={windows}
        onOpenWindow={openWindow} 
        onRestoreWindow={restoreWindow}
      />

      <WindowManager
        windows={windows}
        onClose={closeWindow}
        onFocus={focusWindow}
        onMinimize={minimizeWindow}
        onMaximize={maximizeWindow}
        onUpdate={updateWindow}
      />

      <Taskbar
        onOpenWindow={openWindow}
        windows={windows}
        onRestoreWindow={restoreWindow}
      />
    </div>
  );
};